/// <amd-module name="Test/TestResultsGrid/Components/TestResultLeftView" />
import * as React from "react";
import { Components, VssComponent, IVssComponentContext, IVssComponentProperties, WrappedComponent } from "VSS/Platform/Layout";
import { IViewContextData } from "Test/common-util/Common"
import { TestResultsTree } from "Test/TestResultsGrid/Components/TestResultsGrid";
import { TestResultsListViewActionCreator } from "Test/TestResultsGrid/Actions/TestResultsGridActionsCreator";
import { TestResultsGridActionsHub, TestResultsLeftViewActionHub } from "Test/TestResultsGrid/Actions/TestResultsGridActionHub";
import { TestResultsStore, ITestResultsState } from "Test/TestResultsGrid/Store/TestResultsTreeStore";
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";
import { FilterState } from "Test/common-util/Contracts/Filters";
import { TestResultsGroupPivots } from "Test/common-util/Common";

export interface ITestResultsLeftViewProps extends IVssComponentProperties {
    artifactData: IViewContextData;
    onGridRowClick: (row: ITestResultTreeData) => void
    testResultsLeftViewActionHub: TestResultsLeftViewActionHub;
    showGridComponents: boolean;
    gridActionHub: TestResultsGridActionsHub;
    gridStore: TestResultsStore;
    gridActionCreator: TestResultsListViewActionCreator;
    isNoConfigRuns?: boolean;
    isOnlyRunFetch?: boolean;
    isDetailsPanelOpened?: boolean;
}

export class TestResultsLeftView extends VssComponent<ITestResultsLeftViewProps, {}>{

    private _actionCreator: TestResultsListViewActionCreator;
    private _store: TestResultsStore;
    public constructor(props: ITestResultsLeftViewProps, context: IVssComponentContext) {
        super(props, context);

        this._store = this.props.gridStore;
        this._actionCreator = this.props.gridActionCreator;
    }

    public componentDidMount() {
        this.props.testResultsLeftViewActionHub.enableViewMoreTests.addListener(this._onViewMoreTestsEnable);
    }

    public componentWillUnmount() {
        this.props.testResultsLeftViewActionHub.enableViewMoreTests.removeListener(this._onViewMoreTestsEnable);
    }

    public render(): JSX.Element | null {
        return <div className="flex-column flex-grow scroll-hidden test-results-left-view">
            {
                this.props.showGridComponents &&
                <WrappedComponent dependencies={["ms.vss-test-web.testResultsGridToolbar"]} wrappedType="test-results-grid-toolbar" context={this.props.artifactData}
                    treeStore={this._store}
                    onGroupByChange={this.onGroupByChange}
                    onFilterChange={this.onFilterChange}
                    onColumnsChange={this.onColumnsChange}
                    onViewMoreTestsClicked={this.onViewMoreTestsClicked}
                    onFlakyStateChange={this._onFlakyStateChanged}
                    parentActionHub={this.props.testResultsLeftViewActionHub}
                    isNoConfigRuns={this.props.isNoConfigRuns}
                />
            }
            <div className="scroll-auto flex-column flex-grow">
                <TestResultsTree artifactData={this.props.artifactData}
                    actionCreator={this._actionCreator}
                    onRowClick={this.props.onGridRowClick}
                    store={this._store}
                    showTestResultsGrid={this.props.showGridComponents}
                    isNoConfigRuns={this.props.isNoConfigRuns}
                    isOnlyRunFetch={this.props.isOnlyRunFetch}
                    isDetailsPanelOpened={this.props.isDetailsPanelOpened}
                />
            </div>
        </div>
    }

    private onGroupByChange = (groupByValue: TestResultsGroupPivots) => {
        this._actionCreator.onGroupByChanged(this.props.artifactData, groupByValue);
    }

    private onFilterChange = (filterState: FilterState) => {
        this._actionCreator.onFilterChanged(this.props.artifactData, filterState);
    }

    private onColumnsChange = (columns: string[]) => {
        this._actionCreator.onColumnsChange(this.props.artifactData, columns);
    }

    private onViewMoreTestsClicked = () => {
        this._actionCreator.onInProgressResults();
    }

    private _onFlakyStateChanged = () => {
        this._actionCreator.onFlakyStateChanged();
    };

    private _onViewMoreTestsEnable = () => {
        this._actionCreator.initialize(this.props.artifactData);

        // Removing the listener as we want to refresh the grid only for the first time.
        this.props.testResultsLeftViewActionHub.enableViewMoreTests.removeListener(this._onViewMoreTestsEnable);
    }
}